// @ts-nocheck
import React, { useEffect } from "react"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"

import moment from "moment"
import { getUrlParams } from "../../../util"

import { Flex } from "../../../container-components"
import { TextButton } from "../../../element-components"

export const DATE_OPTIONS = [
	{
		key: "today",
		label: "Today",
		value: new Date(moment().startOf("day").startOf("day")).getTime()
	},
	{
		key: "last-two-days",
		label: "Last Two Days",
		value: new Date(moment().subtract(1, "d").startOf("day")).getTime()
	},
	{
		key: "last-seven-days",
		label: "Last Seven Days",
		value: new Date(moment().subtract(6, "d").startOf("day")).getTime()
	},
	{
		key: "one-month",
		label: "One Month",
		value: new Date(moment().subtract(1, "month").startOf("day")).getTime()
	},
	{
		key: "two-month",
		label: "Two Months",
		value: new Date(moment().subtract(2, "month").startOf("day")).getTime()
	},
	{
		key: "one-year",
		label: "One Year",
		value: new Date(moment().subtract(1, "year").startOf("day")).getTime()
	}
]



export const setSearchParamsString = ({
	location,
	defaultParams,
	history,
	newValue
}) => {
	const currentParams = getUrlParams({ location: window.location })

	let params = Object.entries(defaultParams).reduce((params, [key, value]) => {
		if (newValue?.[key]?.value) params += `${key}=${newValue[key].value}&`
		else if (key in currentParams) params += `${key}=${currentParams[key]}&`
		else params += `${key}=${value.value}&`

		return params
	}, "info")

	params = Object.entries(currentParams)
		.reduce((params, [key, value]) => {
			if (!params.includes(key) && newValue?.[key]?.value !== null) params += `${key}=${value}&`
			return params
		}, params)
		.slice(0, -1)

	window.history.replaceState(null, null, `${location.pathname}${params}`)
	return params
}

const GlobalFilter= ({ globalFilterValues, requestFn }) => {
	const location = useLocation()
	const history = useNavigate()
	const [searchParams, setSearchParams] = useSearchParams()

	const globalFilterHandler = async ({ value, communication, filterKey }) => {
		const params = setSearchParamsString({
			location,
			history,
			defaultParams: globalFilterValues,
			newValue: { [filterKey]: { value } }
		})

		await requestFn({ params })
	}

	useEffect(() => {
		setSearchParams(window?.location.search, { replace: true })
	}, [location.search])

	return (
		<Flex yAlign="center" width="90%">
			{Object.entries(globalFilterValues).map(([filterKey, filterObject]) => {
				const { communication, options } = filterObject
				const filterStatus = searchParams.get(filterKey)

				return (
					<Flex yAlign="center" width="90%">
						{options.map((filter) => {
							const isSelected = filterStatus === filter.value.toString()

							return (
								<TextButton
									variant="t5"
									text={filter.label}
									style={{ textTransform: "capitalize" }}
									color={isSelected ? "tertiary" : "primary"}
									onClick={() =>
										globalFilterHandler({
											value: filter.value,
											communication,
											filterKey
										})
									}
								></TextButton>
							)
						})}
					</Flex>
				)
			})}
		</Flex>
	)
}

export default GlobalFilter
